<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <!-- <el-breadcrumb-item to="/feature/intro">学院概况</el-breadcrumb-item> -->
        <el-breadcrumb-item :to="`${$subsitePrefix}/major`">专业信息</el-breadcrumb-item>
        <el-breadcrumb-item>教学资料</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content detail-content">
        <div class="left">
          <side-nav :data="relativeList"></side-nav>
        </div>
        <div class="right">
          <column-header2 :data="metaData">
            <div slot="right" class="right_btns">
              <span v-if="!isTop || isViewFile" class="cursor text-blue" @click="returnParent">
                <i class="el-icon-back text-blue" />
                <span class="text-blue">返回上级</span>
              </span>
            </div>
          </column-header2>
          <div class="content">
            <material-view v-if="isViewFile" :file-id="fileId" :file-name="fileName" @back="returnBack" />
            <div v-else class="mc-layout">
              <!-- <div class="mc-header">
                <div class="mc-header-left">
                  <span v-if="isTop" class="text-blue">根目录</span>
                  <div v-else class="mc-navigation">

                    <span class="text-diver">|</span>
                    <span class="text-blue cursor" @click="returnParent(0)">全部</span>
                    <span class="text-diver">/</span>
                    <span class="text-gray">{{ catalogName }}</span>
                  </div>
                </div>
                <div class="mc-header-right">

                </div>
              </div> -->
              <no-data v-if="dataList.length == 0" />
              <div v-else class="mc-content">
                <div v-for="(item, i) in dataList" :key="i" class="mc-item">
                  <div class="mc-item-left">
                    <div class="item-img-box">
                      <img @error="imgError" v-if="item.dataType == 1" class="img-folder" src="/img/filetype/folder.png" alt />
                      <img @error="imgError" v-else :src="
                          `/img/filetype/${getFileType(
                            item.ContentFileFileExtension
                          )}`
                        " class="img-file" alt />
                    </div>
                    <div class="item-text-box">
                      <span class="file-name text-black" @click="handleView(item)">{{ item.Name }}</span>
                    </div>
                  </div>
                  <div class="mc-item-right">
                    <div v-if="!item.isEdit" class="mc-item-btns">
                      <span v-if="item.dataType == 2" v-down="item" class="el-button el-button--text ml-20  el-button--small">
                        <i class="el-icon-download" />下载
                      </span>
                    </div>
                    <div class="item-text-box mc-text-right">
                      <span v-if="item.dataType == 2" class="text-black file-size">{{ getFileSize(item.ContentFileFileSize) }}</span>
                      <span class="text-gray file-date">{{
                        item.UpdatedTime
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllList } from "@/api/content-data";
import Vue from "vue";
import NoData from "@/components/Common/EmptyData";
import MaterialView from "@/components/Common/MaterialView";
import contentTools from "@/mixins/content-tools";
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";
export default {
  name: "CommonMaterial",
  components: {
    NoData,
    MaterialView,
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader
  },
  mixins: [contentTools],
  data() {
    return {
      majorId: "",
      activeId: "",
      folderName: "",
      visible: false,
      dataList: [],
      catalogTableId: "TeachingMaterialsType",
      contentTableId: "TeachingMaterials",
      parentId: "",
      lastParentId: "",
      catalogName: "",
      levelIndex: [],
      fullscreenLoading: true,
      isViewFile: false,
      fileId: "",
      fileName: "",
      moduleCode: "MajorMaterial",
      metaData: {
        name: "教学资料"
      }
    };
  },
  computed: {
    ...mapState("college", ["currentMajor", "relativeList"]),
    isTop() {
      if (this.parentId === this.activeId) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (this.currentMajor) {
      this.activeId = this.currentMajor.Id;
      this.majorId = this.currentMajor.BaseMajorId;
      this.initialize();
    } else {
      this.$router.push(this.$subsitePrefix + "/major");
    }
  },
  methods: {
    async initialize() {
      Vue.directive("down", {
        inserted: (el, binding) => {
          el.style.cssText = "cursor: pointer;color:write;";
          el.addEventListener("click", () => {
            console.log(binding.value);
            const link = document.createElement("a");
            const url = binding.value.ContentFileFileDownload;
            const name = binding.value.ContentFileFileName;
            // 这里是将url转成blob地址，
            fetch(url)
              .then(res => res.blob())
              .then(blob => {
                // 将链接地址字符内容转变成blob地址
                link.href = URL.createObjectURL(blob);
                console.log(link.href);
                link.download = name;
                document.body.appendChild(link);
                link.click();
              });
          });
        }
      });
      this.parentId = this.activeId;
      this.levelIndex = [];
      this.levelIndex.push(this.parentId);
      await this.getDataList();
    },
    async getDataList() {
      this.fullscreenLoading = true;

      this.dataList = [];
      var queryStr = JSON.stringify([
        { Key: "Module", Value: this.moduleCode, CompareType: 0 },
        { Key: "Parent", Value: this.parentId, CompareType: 0 }
      ]);
      var queryData = {
        TableId: this.catalogTableId,
        School: this.userSid,
        Major: this.majorId,
        queryStr: queryStr
      };
      var res = await getAllList(queryData);
      console.log("catalog", res.Result);
      var catalogList = [];
      res.Result.map(m => {
        var catalog = {
          Id: m.Id,
          Name: m.Name,
          dataType: 1,
          parentId: m.Parent,
          UpdatedTime: m.UpdatedTime
        };
        catalogList.push(catalog);
      });
      this.dataList = catalogList;
      queryData.TableId = this.contentTableId;
      var resFile = await getAllList(queryData);
      resFile.Result.map(m => {
        var file = {
          Id: m.Id,
          Name: m.Name,
          dataType: 2,
          IssueTime: m.IssueTime,
          parentId: m.Parent,
          UpdatedTime: m.UpdatedTime,
          ContentFile: m.ContentFile,
          ContentFileFileName: m.ContentFileFileName,
          ContentFileFileExtension: m.ContentFileFileExtension,
          ContentFileFilePath: m.ContentFileFilePath,
          ContentFileFileSize: m.ContentFileFileSize,
          ContentFileFileDownload:
            "/files/" + m.ContentFileFilePath.replace(/\\/g, "/")
        };
        this.dataList.push(file);
      });
      this.fullscreenLoading = false;
    },
    async handleView(item) {
      if (item.dataType === 1) {
        this.lastParentId = this.parentId;
        this.parentId = item.Id;
        this.levelIndex.push(item.Id);
        this.catalogName = item.Name;
        console.log(this.levelIndex, this.catalogName);
        await this.getDataList();
      } else {
        this.fileId = item.ContentFile;
        this.fileName = item.Name;
        this.isViewFile = true;
        // let routeUrl = this.$router.resolve({
        //   path: "/Common/File/View/" + item.ContentFile,
        //   query: {}
        // });
        // window.open(routeUrl.href, "_blank");
      }
      console.log(11111111, item.Id);
    },
    async returnParent(level) {
      if (this.isViewFile) {
        this.isViewFile = false;
      } else {
        console.log(this.levelIndex);
        if (level === 0) {
          this.parentId = this.activeId;
          this.lastParentId = "";
        } else {
          this.parentId = this.levelIndex[this.levelIndex.length - 2];
          this.levelIndex.splice(-1, 1);
        }
        await this.getDataList();
      }
    },
    returnBack() {
      this.isViewFile = false;
    }
  }
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/mcstyle.scss';
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .detail-content {
    padding: 16px 0 40px 0;
    display: flex;
    justify-content: space-between;
    ::v-deep .comp-column-header {
      padding: 16px 0 32px 0;
    }
    .left {
      width: 200px;
      margin-right: 24px;
    }
    .right {
      flex: 1;
      .right_btns {
        padding-right: 20px;
      }
      ::v-deep .content {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        line-height: 1.8em;
        p {
          text-indent: 2em;
          padding-bottom: 0.4em;
        }
        h6,
        h5,
        h4,
        h3,
        h2,
        h1 {
          padding-bottom: 0.8em;
        }
      }
    }
  }
}
</style>
